export const API_ROUTES = {
  oauth2: 'sessions/oauth2',
  googleSSO: 'admin/sessions/sso',

  // User
  users: 'users',

  // Company
  companiesOverview: 'admin/companies/overview',
  companiesSearch: 'admin/companies/search',
  companies: 'admin/companies',
  companiesBranchLocation: 'admin/companies/branchs-location',
  allCompanies: 'admin/companies/all',
  getAllCompaniesompanies: 'admin/companies',
  company: (id: string) => `admin/companies/${id}`,
  companyLinks: (id: string) => `admin/companies/${id}/links`,
  companyBranch: (id: string) => `admin/companies/${id}/branch-companies`,
  companyAllBranch: (id: string) =>
    `admin/companies/${id}/all-branch-companies-overview`,
  companyEvents: (id: string) => `admin/companies/${id}/all-branch-events`,
  // Company Note
  companiesNotes: (companyId: string) => `admin/companies/${companyId}/notes`,
  companiesNotesByNoteId: (companyId: string, companyNoteId: string) =>
    `admin/companies/${companyId}/notes/${companyNoteId}`,

  // Company Employee
  companiesEmployees: 'admin/users',
  companiesEmployeesCSVCompanyId: (companyId: string) =>
    `admin/users/csv/${companyId}`,
  importMemberEventCSVCompanyId: (companyId: string) =>
    `import/csv-member-event/${companyId}`,

  // Company Tracking
  companiesTracking: (companyId: string) =>
    `admin/user-usage-log/company/${companyId}`,
  companiesTrackingExportCSV: (companyId: string) =>
    `admin/user-usage-log/company/${companyId}/download`,

  // Admin User
  usersOverview: 'admin/users/overview',
  usersSearch: 'admin/users/search',
  adminUsers: 'admin/users',
  adminUser: (id: string) => `admin/users/${id}`,
  adminUserPhoneLookup: (id: string) => `admin/users/${id}/phone-lookup`,

  // Admin User Note
  adminUserNotes: (userId: string) => `admin/users/${userId}/notes`,
  adminUserNotesByNoteId: (userId: string, userNoteId: string) =>
    `admin/users/${userId}/notes/${userNoteId}`,

  adminUpdateUserNotes: `/users/update-user-note`,

  // Admin User Tracking
  adminUserTracking: (userId: string) => `admin/user-usage-log/user/${userId}`,
  adminUsersExportCSV: (userId: string) =>
    `admin/user-usage-log/user/${userId}/download`,

  adminEventsInstances: 'admin/events/instances',
  adminEventsInstance: (eventInstanceId: string) =>
    `admin/events/instances/${eventInstanceId}`,

  //Provider
  providers: 'admin/providers',
  providerById: (providerId: string) => `admin/providers/${providerId}`,
  createProvider: `admin/providers/create`,
  editProvider: `admin/providers/edit`,
  adminProvider: (id: string) => `admin/providers/${id}`,

  //Template Task List
  templateTaskList: 'admin/templateTaskList/all',
  templateTaskListCompany: 'admin/templateTaskList/company/all',

  //templateTaskList
  templateTaskListById: (templateTaskListId: string) =>
    `admin/templateTaskList/${templateTaskListId}`,
  createTemplateTaskList: `admin/templateTaskList/create`,
  editTemplateTaskList: `admin/templateTaskList/edit`,
  removeTemplateTaskList: (id: string) => `admin/templateTaskList/${id}`,

  //event
  getMemberEventList: `/userEvents/event-list`,

  //TemplateTask
  templateTask: (templateTaskListId: string) =>
    `admin/templateTask/list/${templateTaskListId}`,

  //templateTask
  templateTaskById: (templateTaskId: string) =>
    `admin/templateTask/${templateTaskId}`,
  createTemplateTask: `admin/templateTask/create`,
  editTemplateTask: `admin/templateTask/edit`,
  removeTemplateTask: (id: string) => `admin/templateTask/${id}`,

  //communication_templates
  getCommunicationTemplates: `/communicationTemplates`,

  deleteUser: (userId: string) => `admin/users/${userId}`,

  deleteCompany: (companyId: string) => `admin/companies/${companyId}`,

  companyLinkNonEmployeeSponsoredAccount: (id: string) =>
    `admin/companies/${id}/linksNonEmployeeSponsor`,

  //user checks-ins
  getUserCheckIns: (userId: string) => `admin/users/check-ins/${userId}`,
  exportUserCheckIns: (userId: string) =>
    `admin/users/check-ins/${userId}/download`,

  getCompaniesUsers: (companyId: string) => `admin/users/${companyId}/users`,

  getUserEvents: (userId: string) => `admin/users/${userId}/user-events`,
  deleteUserEvent: `admin/users/user-event`,

  companiesUsersExportCSV: (companyId: string) =>
    `admin/users/${companyId}/users/download`,

  migrationEvents: 'admin/events/migrations',
  migrationTaskInfo: 'admin/events/migrations/taskInfo',

  getAllUsers: `admin/users/all-users`,

  //company template task list
  allCompanyTemplateTaskList: 'admin/companyTemplateTaskList/all',
  companyTemplateTaskListById: (id: string) =>
    `admin/companyTemplateTaskList/${id}`,
  createCompanyTemplateTaskList: `admin/companyTemplateTaskList`,
  editCompanyTemplateTaskList: `admin/companyTemplateTaskList`,

  // Messages Sent (Outreach Report)
  companiesMessagesSent: (companyId: string) =>
    `admin/companies/${companyId}/messages-sent`,
  companiesMessagesSentEventTypes: (companyId: string) =>
    `admin/companies/${companyId}/messages-sent/event-types`,

  // Triage replies: connecting the support@ Gmail inbox
  gmailConnection: 'admin/gmail-connection',
  gmailConnectionStart: 'admin/gmail-connection/start',
  gmailConnectionFinish: 'admin/gmail-connection/finish',

  //inbox
  inboxConversations: 'admin/conversations',
  inboxConversationById: (conversationId: string) =>
    `admin/conversations/${conversationId}`,
  // A member's whole conversation, across however many Intercom segments it
  // is stored in. This is what the queue acts on.
  inboxMemberConversation: (memberUserId: string) =>
    `admin/conversations/member/${memberUserId}`,
  inboxAssignees: 'admin/conversations/assignees',
  inboxCounts: 'admin/conversations/counts',
  inboxMemberEscalate: (memberUserId: string) =>
    `admin/conversations/member/${memberUserId}/escalate`,
  inboxMemberDeescalate: (memberUserId: string) =>
    `admin/conversations/member/${memberUserId}/deescalate`,
  inboxMemberStatusHistory: (memberUserId: string) =>
    `admin/conversations/member/${memberUserId}/status-history`,
  conversationMentionTag: (conversationMentionTagId: string) =>
    `admin/conversations/mention-tags/${conversationMentionTagId}`,

  //intercom
  getConversations: (userId: string) => `admin/users/${userId}/conversations`,
  draftConversationReply: (userId: string) =>
    `admin/users/${userId}/conversations/draft-reply`,
  summarizeConversation: (userId: string) =>
    `admin/users/${userId}/conversations/summary`,
  adminDashboardStats: (companyId: string) =>
    `/admin/companies/${companyId}/stats`,

  //Escalation
  getEscalationCompany: (companyId: string) =>
    `admin/companies/${companyId}/escalation`,
  updateEscalationCompany: (companyId: string) =>
    `admin/companies/${companyId}/escalation`,
  getEscalationUsers: (companyId: string) =>
    `admin/companies/${companyId}/escalation/users`,

  //AI Context
  getCompanyAiContext: (companyId: string) =>
    `admin/companies/${companyId}/ai-context`,
  updateCompanyAiContext: (companyId: string) =>
    `admin/companies/${companyId}/ai-context`,

  //Tag
  getConversationTag: `tag`,

  //inactive-reason
  getInactiveReasons: `/inactive-reasons`,

  //exist phone
  existPhone: `/users/exist-phone`,

  //Triage
  getTriageOptions: `admin/triages/options`,
  createTriage: `admin/triages`,
  updateTriage: `admin/triages`,
  deleteTriage: `admin/triages`,
  // The inbox triage client. Same collection as createTriage above, named for
  // what it is so a GET does not read as a create.
  triages: `admin/triages`,
  triageReply: (triagesId: string) => `admin/triages/${triagesId}/reply`,
  triageNoteResend: (triagesId: string, triagesNotesId: string) =>
    `admin/triages/${triagesId}/notes/${triagesNotesId}/resend`,
  triageStatus: (triagesId: string) => `admin/triages/${triagesId}/status`,

  //All NOTE
  getAllNotes: (userId: string) => `/userEvents/${userId}/all`,

  getPurchasedEventTypes: () => `admin/companies/purchased-event-types`,
};
